import { utcToZonedTime } from 'date-fns-tz';

// スペースが入るとエラーになるのを回避するためのnew Date()
export const newDate = (dateInput: string | number = '') => {
  if (dateInput) {
    // 数値（タイムスタンプ）の場合
    if (typeof dateInput === 'number') {
      return utcToZonedTime(new Date(dateInput), 'Asia/Tokyo');
    }
    // 文字列の場合
    const replacedDateStr = dateInput.replace(/ /g, 'T'); // 半角スペースをTに置換
    return new Date(replacedDateStr);
  }
  return utcToZonedTime(new Date(), 'Asia/Tokyo');
};
